import React, { useEffect, useContext, useState } from 'react';
import { Menu, useSidebarState } from 'react-admin';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Box, Button, Typography, Badge } from '@mui/material';
import EventNoteIcon from '@mui/icons-material/EventNote';
import MailIcon from '@mui/icons-material/Mail';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../functions/apiService';
import {  DataIcon,  LogoutIcon,  SettingsIcon,  WorkManagementIcon,  StocksIcon, VacationBid ,  SystemIcon,  InventoryIcon,  HelpIcon,  CertificateIcon,  OvertimeSignup, VolunteerSignupIcon, PayrollIcon,  ReportsIcon,  AdjustHoursIcon, ChangePasswordIcon,  ChecklistIcon,  MyChecklistIcon,  MyTickets,  ResourceAssignment, PositionAssignment, CancelledAssignmentsIcon, MessagngIcon,  ManageOvertimeIcon,	ShiftCallsIcon, DailyCheckView, DailyCheckList, ViewBidIcon, MaintenanceFormIcon} from "./Svg";
import AuthContext from "../../context/AuthContext";
import { logout } from "../../context/AuthContext";
import { json } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';

export const MyMenu = () => {
  const [open, setOpen] = useSidebarState(true);
  const { permission, pages } = useContext(AuthContext);
  const [department, setDepartment] = useState('');
  const [name, setName] = useState('');
  const navigate = useNavigate();
  const [notificationLength, setNotificationLength] = useState([])
	const [allowedVars , setAllowedVars] = useState({});
	const [maintenanceLink , setMaintenanceLink] = useState('');

  useEffect(() => {
    let content = document.querySelector('#main-content');
    if (content) {
      if (open) {
        document.querySelector('#main-content').style.width = 'calc(100vw - 280px)';
      } else {
        document.querySelector('#main-content').style.width = 'calc(100vw - 72px)';
      }
    }
  }, [open]);

  useEffect(() => {
    const storedDepartment = localStorage.getItem('department');
    const storedName = localStorage.getItem('user');
    if (storedDepartment) {
      setDepartment(storedDepartment);
    }

    if (storedName) {
      const userName = JSON.parse(storedName);
      setName(userName.fullName);
    }
  }, []);

  const handleClick = () => {
    navigate('/firehouse/notifications');
  };

  const loadNotificationsCount = () => {
    ApiService.get('/notificationsHeader')
      .then(({ data }) => {
        setNotificationLength(data?.data)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  useEffect(() => {
    loadNotificationsCount()
  }, [])

	let getAllowedVars = () => {
		ApiService.get('/v3Variables')
			.then((res) => {
				setAllowedVars(res?.data?.data)
				setMaintenanceLink(res?.data?.data?.V3_MAINTAINANCE_FORM)
			}).catch(({ error }) => {
				console.error('error', error)
			});
	}

	useEffect(()=>{
		getAllowedVars();
	}, [])


  return (
    <>
      <Menu
        sx={{
          margin: 0,
          background: 'radial-gradient(circle at 0%  ,#5362EBd1 -80%,#1E1E1E 40%)',
          backgroundPostion: 'left',
          height: '100vh',
          color: '#fff',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: open ? 'space-between' : 'center',
            height: '110px',
          }}
        >
          <img
            className='ms-3 my-3'
            src='/images/LogoColor.svg'
            style={open ? { display: 'block' } : { display: 'none' }}
          />
          <div className='mt-4' style={{ display: open ? 'block' : 'none' }}>
            <Badge badgeContent={notificationLength} sx={{
              '& .MuiBadge-badge': {
                backgroundColor: '#f5f5f5',
                color: '#2E3238',
                marginRight: '3px',
                marginTop: '3px'
              },
            }}>
              <div onClick={handleClick} className="notification-icon">
                <img src='/images/notification.svg' />
              </div>
            </Badge>
          </div>
          <Button
            sx={{
              color: '#FFF',
              height: '74px',
              width: '74px',
              '&.MuiButton-root:active': { backgroundColor: '#2E3238' },
              '&.MuiButton-root:hover': { backgroundColor: 'transparent' },
            }}
            onClick={() => setOpen(!open)}
            endIcon={
              open ? (
                <KeyboardDoubleArrowLeftIcon style={{ fontSize: 30 }} />
              ) : (
                <KeyboardDoubleArrowRightIcon style={{ fontSize: 30 }} />
              )
            }
          ></Button>

          {/* <SidebarToggleButton icon={<KeyboardDoubleArrowLeftIcon />}></SidebarToggleButton> */}
        </Box>

        <Box
          className='menu-scroll-css'
          sx={{ marginBottom: '200px', height: '80vh', position: 'sticky', overflow: 'scroll' }}
        >
          <Menu.Item
            className={open ? 'py-3 m-1 mx-3 rounded-4 ' : 'py-3 my-1'}
            sx={{
              color: 'white',
              '&.RaMenuItemLink-active': {
                backgroundColor: '#2E3238 !important',
                borderRadius: '4px !important',
                color: 'white',
              },
              fontFamily: 'Helvetica',
            }}
            to='/firehouse/user-settings'
            primaryText='User Settings / Profile'
            leftIcon={<SettingsIcon width='24px' height='24px' />}
					/>
					
          <Menu.Item
            className={open ? 'py-3 m-1 mx-3 rounded-4 ' : 'py-3 my-1'}
            sx={{
              color: 'white',
              '&.RaMenuItemLink-active': {
                backgroundColor: '#2E3238 !important',
                borderRadius: '4px !important',
                color: 'white',
              },
              fontFamily: 'Helvetica',
            }}
            to='/firehouse/calendar'
            // to="/firehouse/schedule"
            primaryText='Work Management'
            leftIcon={<WorkManagementIcon width='20px' height='20px' />}
					/>
					
					<Menu.Item
						className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
						sx={{
							color: 'white',
							"&.RaMenuItemLink-active": {
								backgroundColor: "#2E3238 !important",
								borderRadius: "4px !important",
								color: 'white',
							},
							fontFamily: "Helvetica",
						}}
						to="/firehouse/watch-party"
						primaryText="Watch Party"
						hidden={!pages.includes('MENU_WATCH_PARTY')}
						leftIcon={<EventNoteIcon width="20px" height="20px" />}
					/>

					<Menu.Item
						className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
						sx={{
							color: 'white',
							"&.RaMenuItemLink-active": {
								backgroundColor: "#2E3238 !important",
								borderRadius: "4px !important",
								color: 'white',
							},
							fontFamily: "Helvetica",
						}}
						to="/firehouse/leave-book"
						primaryText="Leave Book"
						hidden={!pages.includes('MENU_LEAVE_BOOK')}
						leftIcon={<EventNoteIcon width="20px" height="20px" />}
					/>

          <Menu.Item
            className={open ? 'py-3 m-1 mx-3 rounded-4 ' : 'py-3 my-1'}
            sx={{
              color: 'white',
              '&.RaMenuItemLink-active': {
                backgroundColor: '#2E3238 !important',
                borderRadius: '4px !important',
                color: 'white',
              },
              fontFamily: 'Helvetica',
            }}
            to='/firehouse/neris-settings'
            primaryText='NERIS Settings'
            hidden={!pages.includes('V3_NERIS_MODULE')}
            leftIcon={<SettingsApplicationsIcon sx={{ fontSize: '25px' }} />}
          />

          <Menu.Item
            className={open ? 'py-3 m-1 mx-3 rounded-4 ' : 'py-3 my-1'}
            sx={{
              color: 'white',
              '&.RaMenuItemLink-active': {
                backgroundColor: '#2E3238 !important',
                borderRadius: '4px !important',
                color: 'white',
              },
              fontFamily: 'Helvetica',
            }}
            to='/firehouse/incidents'
            primaryText='Incidents'
            hidden={!pages.includes('V3_NERIS_MODULE')}
            leftIcon={<EventNoteIcon width='20px' height='20px' />}
          />

          <Menu.Item
            className={open ? 'py-3 m-1 mx-3 rounded-4 ' : 'py-3 my-1'}
            sx={{
              color: 'white',
              '&.RaMenuItemLink-active': {
                backgroundColor: '#2E3238 !important',
                borderRadius: '4px !important',
                color: 'white',
              },
              fontFamily: 'Helvetica',
            }}
            to='/firehouse/pre-plans'
            primaryText='Pre Plans'
            hidden={!pages.includes('V3_NERIS_MODULE')}
            leftIcon={<HomeIcon sx={{ fontSize: '25px' }} />}
          />

          <Menu.Item
            className={open ? 'py-3 m-1 mx-3 rounded-4 ' : 'py-3 my-1'}
            sx={{
              color: 'white',
              '&.RaMenuItemLink-active': {
                backgroundColor: '#2E3238 !important',
                borderRadius: '4px !important',
                color: 'white',
              },
              fontFamily: 'Helvetica',
            }}
            to='/firehouse/inspections'
            primaryText='Inspections'
            hidden={!pages.includes('V3_NERIS_MODULE')}
            leftIcon={<SearchIcon sx={{ fontSize: '25px' }} />}
          />

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/overtime-signup"
            primaryText="Overtime Signup"
            hidden={!pages.includes('V3_OVERTIME_SIGNUP_FORM')}
            leftIcon={<OvertimeSignup width="24px" height="24px" />}
					/>

					<Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/volunteer-signup"
            primaryText={allowedVars?.V3_VERBIAGE_VOLUNTEER ? "Per-diem Signup" : "Volunteer Signup"}
						hidden={!pages.includes('V3_Volunteer_Signup')}
						leftIcon={<VolunteerSignupIcon width="24px" height="24px" />}
					/>
					
					<Menu.Item
						className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
						sx={{
							color: 'white',
							"&.RaMenuItemLink-active": {
								backgroundColor: "#2E3238 !important",
								borderRadius: "4px !important",
								color: 'white',
							},
							fontFamily: "Helvetica",
						}}
						to="/firehouse/my-shift-calls"
						primaryText="My Shift Calls"
						hidden={!pages.includes('V3_NEW_FILL_STRUCTURE')}
						leftIcon={<ShiftCallsIcon width="24px" height="24px" />}
					/>

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/manage-overtime"
            primaryText="Manage Overtime"
            hidden={permission.includes('Emp_Auth') && permission.includes('OT_Auth') ? false : true}
            leftIcon={<ManageOvertimeIcon width="20px" height="20px" />}
          />

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/vacation-bids"
            primaryText="Vacation Bids"
            // hidden={!allowedVars?.V3_VACATION_BIDDING && !permission.includes('Emp_Auth')}
            hidden={!permission.includes('Emp_Auth')}
            leftIcon={<VacationBid width="20px" height="20px" />}
          />

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/vacation-bid-user"
            primaryText="My Vacation Bids"
            // hidden={!allowedVars?.V3_VACATION_BIDDING && permission.includes('Emp_Auth')}
            hidden={permission.includes('Emp_Auth')}
            leftIcon={<VacationBid width="20px" height="20px" />}
          />

					<Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/position-assignment"
            primaryText="Position Assignment"
            hidden={permission.includes('Emp_Auth') && pages.includes('V3_Volunteer_Signup')? false : true}
            // hidden={permission.includes('Emp_Auth') ? false : true}
            leftIcon={<PositionAssignment width="24px" height="24px" />}
          />

					<Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/cancelled-assignments"
            primaryText="Cancelled Assignments"
						hidden={permission.includes('Emp_Auth') && pages.includes('V3_Volunteer_Signup')? false : true}
						leftIcon={<CancelledAssignmentsIcon width="25px" height="24px" />}
					/>

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/schedule-override"
            primaryText="Resource Assignment"
            hidden={!pages.includes('SCHEDULE_SELECT_POSITION_DAY_NIGHT')}
            leftIcon={<ResourceAssignment width="24px" height="24px" />}
          />

          {pages.includes('V3_INVENTORY_MODULE') &&
            <Menu.Item
              className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
              sx={{
                color: 'white',
                "&.RaMenuItemLink-active": {
                  backgroundColor: "#2E3238 !important",
                  borderRadius: "4px !important",
                  color: 'white',
                },
                fontFamily: "Helvetica",
              }}
              to="/firehouse/inventory"
              primaryText="Inventory"
              hidden={!pages.includes('V3_INVENTORY_MODULE')}
              leftIcon={<InventoryIcon width="24px" height="24px" />}
            />
          }

          {pages.includes('V3_INVENTORY_MODULE') &&
            <Menu.Item
              className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
              sx={{
                color: 'white',
                "&.RaMenuItemLink-active": {
                  backgroundColor: "#2E3238 !important",
                  borderRadius: "4px !important",
                  color: 'white',
                },
                fontFamily: "Helvetica",
              }}
              to="/firehouse/checklist"
              primaryText="Checklist Definition"
              // hidden={!pages.includes('V3_OVERTIME_SIGNUP_FORM')}
              leftIcon={<ChecklistIcon width="24px" height="24px" />}
            />
          }

					
          {pages.includes('V3_INVENTORY_MODULE') &&
            <Menu.Item
              className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
              sx={{
                color: 'white',
                "&.RaMenuItemLink-active": {
                  backgroundColor: "#2E3238 !important",
                  borderRadius: "4px !important",
                  color: 'white',
                },
                fontFamily: "Helvetica",
              }}
              to="/firehouse/checklist-chief/data"
              primaryText="Daily Check View"
              // hidden={!pages.includes('V3_OVERTIME_SIGNUP_FORM')}
              leftIcon={<DailyCheckView width="24px" height="24px" />}
            />
          }

          {pages.includes('V3_INVENTORY_MODULE') &&
            <Menu.Item
              className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
              sx={{
                color: 'white',
                "&.RaMenuItemLink-active": {
                  backgroundColor: "#2E3238 !important",
                  borderRadius: "4px !important",
                  color: 'white',
                },
                fontFamily: "Helvetica",
              }}
              to="/firehouse/my-checklist"
              primaryText="My Checklist"
              leftIcon={<MyChecklistIcon width="20px" height="20px" />}
            />
          }

          {
            pages.includes('V3_INVENTORY_MODULE') &&
            <Menu.Item
              className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
              sx={{
                color: 'white',
                "&.RaMenuItemLink-active": {
                  backgroundColor: "#2E3238 !important",
                  borderRadius: "4px !important",
                  color: 'white',
                },
                fontFamily: "Helvetica",
              }}
              to="firehouse/tickets"
              primaryText="My Tickets"
              leftIcon={<MyTickets width="24px" height="24px" />}
            />
          }

					<Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/attribute-management"
            primaryText="Attribute Management"
						hidden={!pages.includes('V3_INVENTORY_MODULE')}
            leftIcon={<ResourceAssignment width="24px" height="24px" />}
          />

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: 'Helvetica',
            }}
            to="/firehouse/certificates"
            primaryText="Certificates"
            hidden={!pages.includes('V3_CERTIFICATE_MODULE') ? true : (pages.includes('V3_CERTIFICATE_MODULE') && permission.includes('Emp_Auth')) ? false : true}
            leftIcon={<CertificateIcon width="24px" height="24px" />}
          />
          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/payroll"
            primaryText="Payroll"
            // hidden={!pages.includes('V3_CERTIFICATE_MODULE') ? true : (pages.includes('V3_CERTIFICATE_MODULE') && permission.includes('Emp_Auth')) ? false : true}
            leftIcon={<PayrollIcon width="24px" height="24px" />}
          />
          {/* <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/adjustHours"
            primaryText="Volunteer"
            hidden={!pages.includes("AVAILABILITY")}
            leftIcon={
              <img src="/images/volunteer.svg" width="24px" height="24px" />
            }
          /> */}

					<Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/personal-payroll-list"
            primaryText="Personal Payroll"
            // hidden={permission.includes('global_admin') && pages.includes('V3_PERSONAL_PAYROLL_ACK')? false : true}
						hidden={!allowedVars?.V3_PERSONAL_PAYROLL_ACK}
            leftIcon={<PayrollIcon width="24px" height="24px" />}
          />

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/view-log"
            primaryText="System"
            hidden={!permission.includes("Schedule_Auth")}
            leftIcon={<SystemIcon width="24px" height="24px" />}
          />

					<Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/view-bids"
            primaryText="View Bids"
            hidden={!pages.includes('VIEWBIDS') ? true : (pages.includes('VIEWBIDS') && permission.includes('Schedule_Auth')) ? false : true}
            leftIcon={<ViewBidIcon width="22px" height="22px" />}
          />

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/reports"
            primaryText="Reports"
            leftIcon={<ReportsIcon width="24px" height="24px" />}
          />

					{/* <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to={maintenanceLink || "#"}
            primaryText="Maintenance Form"
						hidden={!pages.includes("V3_MAINTAINANCE_FORM")}
            leftIcon={<MaintenanceFormIcon width="24px" height="24px" />}
          /> */}

					<Menu.Item
						className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
						sx={{
							color: 'white',
							"&.RaMenuItemLink-active": {
								color: 'white',
							},
							fontFamily: "Helvetica",
						}}
						onClick={(e) => {
							e.preventDefault();
							window.open(maintenanceLink || "#", "_blank", "noopener,noreferrer");
						}}
						to="#" // dummy route to satisfy the 'to' prop
						primaryText="Maintenance Form"
						hidden={!pages.includes("V3_MAINTAINANCE_FORM")}
						leftIcon={<MaintenanceFormIcon width="24px" height="24px" />}
					/>

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/availability"
            primaryText="Availability"
            hidden={!pages.includes("AVAILABILITY")}
            leftIcon={<ManageOvertimeIcon width="22px" height="22px" />}
          />

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/messaging"
            primaryText="Messaging"
            hidden={!permission.includes("SMS_Auth")}
            leftIcon={<MessagngIcon width="22px" height="22px" />}
          />

					<Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/daily-swap-list"
            primaryText="Daily Swap List"
            hidden={!allowedVars?.V3_dailyswap_adjustment}
            leftIcon={<DailyCheckList width="22px" height="22px" />}
          />

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/adjust-hours"
            primaryText="Adjust Hours"
            hidden={permission.includes('Emp_Auth') && permission.includes('OT_Auth') ? false : true}
            leftIcon={<AdjustHoursIcon width="24px" height="24px" />}
          />

					{/* <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            to="/firehouse/change-password"
            primaryText="Change Password"
            leftIcon={<ChangePasswordIcon width="30px" height="27px" />}
          /> */}

          <Menu.Item
            className={open ? "py-3 m-1 mx-3 rounded-4 " : "py-3 my-1"}
            sx={{
              color: 'white',
              "&.RaMenuItemLink-active": {
                // backgroundColor: "#2E3238 !important",
                borderRadius: "4px !important",
                color: 'white',
              },
              fontFamily: "Helvetica",
            }}
            primaryText="Logout"
            onClick={() => logout()}
            to=""
            leftIcon={<LogoutIcon width="24px" height="24px" />}
          />

          {/* <Menu.DashboardItem
            disabled
            className={open ? 'py-3 m-1 mx-3 rounded-4 ' : 'py-3 my-1'}
            sx={{
              color: 'white',
              '&.RaMenuItemLink-active': {
                backgroundColor: '#2E3238 !important',
                borderRadius: '4px !important',
                color: 'white',
              },
              fontFamily: 'Helvetica',
            }}
          /> */}
          {/* <Menu.Item
            className={open ? 'py-3 m-1 mx-3 rounded-4 ' : 'py-3 my-1'}
            sx={{
              color: 'white',
              '&.RaMenuItemLink-active': {
                backgroundColor: '#2E3238 !important',
                borderRadius: '4px !important',
                color: 'white',
              },
              fontFamily: 'Helvetica',
            }}
            to='/firehouse/Workforce'
            disabled
            primaryText='Workforce'
            leftIcon={<StocksIcon width='24px' height='24px' />}
          /> */}
          {/* <Menu.Item
            className={open ? 'py-3 m-1 mx-3 rounded-4 ' : 'py-3 my-1'}
            sx={{
              color: 'white',
              '&.RaMenuItemLink-active': {
                backgroundColor: '#2E3238 !important',
                borderRadius: '4px !important',
                color: 'white',
              },
              fontFamily: 'Helvetica',
            }}
            to='/firehouse/Data'
            disabled
            primaryText='Data'
            leftIcon={<DataIcon width='24px' height='24px' />}
          /> */}
          {/* <Menu.Item
            className={open ? 'py-3 m-1 mx-3 rounded-4 ' : 'py-3 my-1'}
            sx={{
              color: 'white',
              '&.RaMenuItemLink-active': {
                backgroundColor: '#2E3238 !important',
                borderRadius: '4px !important',
                color: 'white',
              },
              fontFamily: 'Helvetica',
            }}
            to='/firehouse/Help'
            disabled
            primaryText='Help / Training'
            leftIcon={<HelpIcon width='24px' height='24px' />}
          /> */}
        </Box>

        <Box
          sx={{
            display: open ? 'block' : 'none',
            backgroundColor: '#BF1D2D',
            position: 'fixed',
            left: 0,
            bottom: 0,
            zIndex: 1000,
            width: '230px',
            paddingTop: '50px',
          }}
          className='rounded-2 mx-3 py-3 px-2'
        >
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <img src='/images/department.svg' alt='icon' style={{ marginRight: '10px' }} />
            <Typography sx={{ fontSize: '14px', color: '#fff', wordWrap: 'break-word' }}>
              {department}
            </Typography>
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', marginTop: '10px' }}>
            <img
              src='/images/user.svg'
              alt='icon'
              style={{ marginLeft: '1px', marginRight: '8px' }}
            />
            <Typography
              sx={{
                fontSize: '14px',
                color: '#fff',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
              }}
            >
              {name}
            </Typography>
          </div>
        </Box>
      </Menu >
    </>
  );
};
